import React from "react";

const Experties = () => {
  return (
    <div>
      <section className="">
        <div
          className="container flex flex-col items-center justify-center p-4 mx-auto"
          bis_skin_checked="1"
        >
          <div
            className="flex flex-row flex-wrap-reverse justify-center"
            bis_skin_checked="1"
          >
            <div
              className="flex flex-col justify-center items-center w-72 px-8 mx-6 my-12 text-center rounded-md  h-96 bg-violet-900 dark:text-gray-800"
              data-aos="fade-up"
              data-aos-duration="2000"
              bis_skin_checked="1"
            >
              <div class="">
                <img
                  src="https://images.vexels.com/media/users/3/224169/isolated/lists/dbfe1f493ad01117fa4ec5ba10150e4d-computer-programming-logo.png"
                  alt=""
                  className="w-28 h-28"
                />
              </div>
              <div class="mt-4 text-center">
                <p class="text-xl text-white font-bold my-2 text-center">
                  Deeper Skillset
                </p>
                <p class="text-md text-white font-normal my-2">
                  {" "}
                  I Have Been in This Web Development Field for More Then 2
                  Years.I Have Done More Than 30 + Project.I Have 20 Clients Who
                  Are Happy with My Work.
                </p>
              </div>
            </div>
            <div
              className="flex flex-col items-center justify-center w-72 px-8 mx-6 my-12 text-center rounded-md h-96 bg-violet-900 dark:text-gray-800"
              data-aos="fade-up"
              data-aos-duration="2000"
              bis_skin_checked="1"
            >
              <div class="">
                <img
                  src="https://cdn4.iconfinder.com/data/icons/shopping-and-finance-5/400/8_developer_writer_author_coding_programming_text_computer_figure-256.png"
                  alt=""
                  className="w-28 h-28"
                />
              </div>
              <div class="mt-2 text-center">
                <p class="text-xl text-white font-bold my-2">Creative Work</p>
                <p class="text-md text-white font-normal my-2">
                  {" "}
                  I Always Like to Implement new Design & Technologies.Always
                  Like to do Something Different & Unique Which is Different
                  From Other.
                </p>
              </div>
            </div>
            <div
              className="flex flex-col items-center justify-center w-72 px-8 mx-6 my-12 text-center rounded-md h-96 bg-violet-900 dark:text-gray-800"
              data-aos="fade-up"
              data-aos-duration="2000"
              bis_skin_checked="1"
            >
              <div class="">
                <img
                  src="https://ouch-cdn2.icons8.com/Mtm4XDnEjQwh00YZ7L9ytArpQCzJxJEOoGSqQ9JDg3s/rs:fit:256:256/czM6Ly9pY29uczgu/b3VjaC1wcm9kLmFz/c2V0cy9zdmcvMjM0/L2Q0NTRhODllLTg0/ZjAtNGFkMS04NTVi/LWViNmVhZjY2YTk4/OS5zdmc.png"
                  alt=""
                  className="w-28 h-28"
                />
              </div>
              <div class="mt-2 text-center">
                <p class="text-xl text-white font-bold my-2">
                  Strong Dedication
                </p>
                <p class="text-md text-white font-normal my-2">
                  {" "}
                  I Always Work Honestly with my All & Best.Deliver Work Within
                  Stipulated time And Very Sincere & Strong in Commitment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experties;
